import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_NLPModel } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onNLPModelsUpdated = new ThunderDispatcherV3('__onNLPModelsUpdated');
export class ModuleFE_NLPModel_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_NLPModel, dispatch_onNLPModelsUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_NLPModel = new ModuleFE_NLPModel_Class();
//# sourceMappingURL=ModuleFE_NLPModel.js.map